
































































import { ModalSize } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { SigningTheme } from '@getaccept/lib-shared/src/signing-theme/types/theme';
import { BrandingHelper } from '@getaccept/lib-shared/src/signing-theme/helpers/branding.helper';
import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import type { SigningPageDocument } from '@getaccept/lib-shared/src/types/signing-page-document';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { AuthenticationStepType } from '@getaccept/lib-shared/src/authentication/types/enums/authentication-step-type';
import type { AuthenticationStep } from '@getaccept/lib-shared/src/authentication/types/authentication-step';
import type { AuthenticationStepInput } from '../authentication/types/authentication-step-input';
import LobbyCard from '../lobby/components/LobbyCard.vue';
import NonActiveDocumentPrompt from '../lobby/components/NonActiveDocumentModal.vue';
import QnA from '../lobby/components/Qna.vue';
import Sms from '../lobby/components/Sms.vue';
import IdentifyRecipient from '../lobby/components/IdentifyRecipient.vue';
import IdentifyDsrRecipient from '../lobby/components/IdentifyDsrRecipient.vue';
import DsrUnavailable from '../lobby/components/DsrUnavailable.vue';
import Consents from '../lobby/components/Consents.vue';
import TopBar from '../signing/components/TopBar.vue';
export default defineComponent({
  name: 'Lobby',
  components: {
    LobbyCard,
    QnA,
    Sms,
    IdentifyRecipient,
    Consents,
    TopBar,
    NonActiveDocumentPrompt,
    IdentifyDsrRecipient,
    DsrUnavailable,
  },
  props: {
    consentSteps: {
      default: () => [],
      type: Array as PropType<AuthenticationStep[]>,
    },
    nextAuthStep: {
      type: Object as PropType<AuthenticationStep>,
      default: undefined,
    },
    submittingResponse: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      required: false,
    },
    isCorrectPin: {
      type: Boolean,
      required: false,
    },
    recalled: {
      type: Boolean,
      required: false,
    },
    showDsrUnavailable: {
      type: Boolean,
    },
    expired: {
      type: Boolean,
      required: false,
    },
    rejected: {
      type: Boolean,
      required: false,
    },
    gdprDeclined: {
      type: Boolean,
      required: false,
    },
    document: {
      type: Object as PropType<SigningPageDocument>,
      default: () => ({}),
    },
    entity: {
      type: Object as PropType<Entity>,
      default: () => ({}),
    },
    theme: {
      type: Object as PropType<SigningTheme>,
      default: () => ({}),
    },
    previewExpired: {
      type: Boolean,
      required: false,
    },
    isDsr: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const showConsents = computed(
      () => !props.gdprDeclined && props.consentSteps && props.consentSteps.length > 0
    );

    const showModal = computed(() => !!props.nextAuthStep || showConsents.value);

    const documentLogo = computed(() => BrandingHelper.getLogoUrl(props.theme));

    const showNonActiveDocumentModal = computed(
      () => props.recalled || props.rejected || props.expired
    );

    const notFoundDescription = computed(() =>
      props.isDsr ? t('dsr_room_not_found_description') : t('document-not-found-lobby-description')
    );

    const notFoundHeader = computed(() =>
      props.isDsr ? t('dsr_room_not_found_title') : t('document-not-found')
    );

    const handleIdentifyRecipient = (answer: AuthenticationStepInput) => {
      emit('identifyRecipient', answer);
    };
    const handleQnaAnswer = (authAnswer: AuthenticationStepInput) => {
      emit('qnaAnswer', authAnswer);
    };
    const handleSendPin = () => {
      emit('sendPin');
    };
    const handleSmsAnswer = (authAnswer: AuthenticationStepInput) => {
      emit('smsAnswer', authAnswer);
    };
    const handleConsentAnswer = (authStepsInput: AuthenticationStepInput[]) => {
      emit('consentAnswer', authStepsInput);
    };

    const handleConsentDecline = () => {
      emit('consentDecline');
    };

    return {
      showConsents,
      showModal,
      handleIdentifyRecipient,
      handleQnaAnswer,
      handleSendPin,
      handleSmsAnswer,
      handleConsentAnswer,
      handleConsentDecline,
      documentLogo,
      showNonActiveDocumentModal,
      AuthenticationStepType,
      ModalSize,
      notFoundDescription,
      notFoundHeader,
    };
  },
});
